import CloseIcon from "@mui/icons-material/Close";
import { Box, IconButton, Modal } from "@mui/material";
import React from "react";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  //   pt: 2,
  px: 4,
  pb: 3,
};
const ShopImageShowModal = ({
  setImageOpenModalShows,
  imageOpenModalShows,
  setImageView,
  imageView,
}) => {
  return (
    <div>
      {" "}
      <Modal
        open={imageOpenModalShows}
        onClose={() => {
          setImageOpenModalShows(false);
        }}
        className="image-view-modal"
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={{ ...style, width: 500 }}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            <IconButton
              onClick={() => {
                setImageOpenModalShows(false);
                setImageView("");
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>
          <img
            src={imageView}
            alt="Full Size Image"
            className="view-shop-image"
            // style={{ maxHeight: "500px" }}
          />
        </Box>
      </Modal>
    </div>
  );
};

export default ShopImageShowModal;
